import React from "react";
import { useTranslation } from "react-i18next";
import { UiPopup } from "../../../_uiComponents/common/UiModal";
import { SomethingWrongModal } from "../../../_uiComponents/Popups/SomethingWrongModal";
import { RedWarningIcon } from "../../../../styles/img/svg/RedWarningIcon";
import { UiButton } from "../../../_uiComponents/common/UiButton";

export const RequestRejectedPopup = (props) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <UiPopup openModal={props?.isOpen} handleClose={() => {}}>
        <SomethingWrongModal
          icon={<RedWarningIcon />}
          message={t("Registration Request Rejected")}
          buttonText={t("Ok")}
          buttonOnClick={props?.handleClose}
          className="df-confirmation-message-popup df-acc-locked-mdl"
          buttonClass="df-ui-dark-bg-btn df-w-90-btn"
        >
          <p>{t("Your registration request has been rejected by the bank.")}</p>
          <p className="mb-0 mt-1">
            {t("For further assistance, please contact")}
          </p>

          <div>
            <a
              className="df-primary-underlined-btn df-modal-support-text"
              href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
            >
              {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
            </a>
          </div>
        </SomethingWrongModal>
      </UiPopup>
    </>
  );
};
